import { CheckoutService } from './checkoutService';
const checkoutService = new CheckoutService();

export const cloudflareCallbackGuest = function (token) {
    checkoutService.getSaferpayIframe(token).then(response => {
        const iframeUrl = response as string;
        if (iframeUrl) {
            $('.kreditkartenIframeWrapper iframe').attr('src', response as string);
            $('.cloudflare-container').hide();
            $('.cc-iframe-container').removeClass('hide');
        }
    });
}
